import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import HouseHoldImg from "../../assets/houshold.jpg";

const HouseHold = () => {
  return (
    <>
      <Helmet>
        <title>Household Removals | Trans World Shipping</title>
        <meta
          name="description"
          content="Reliable household moving services by Trans World Shipping."
        />
        <link
          rel="canonical"
          href="https://transworldshippingcompany.com/services/household-removals"
        />
      </Helmet>

      <TheHouseHold>
        <div className="household-hero">
          <img src={HouseHoldImg} alt="Household Removals" />
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Household Removals</h1>
            <p>
              Efficient and cost-effective solutions for executive transfers and
              personal shipments
            </p>
          </div>
        </div>

        <div className="household-container">
          <div className="hr-section">
            <p>
              If you operate in the Human Resources area of your company and
              need to work with an established leader on a long range plan for
              executive transfers and personal shipments, our senior experts
              will work with you and will provide you with efficient and
              cost-effective solutions.
            </p>
          </div>

          <div className="equipment-section">
            <p>
              For Household Moving companies our warehouse locations operate
              special equipment and loading ramps for automobiles, racing cars
              and equipment for safe and secure handling.
            </p>
          </div>

          <div className="exhibitions-section">
            <p>
              We are also recognized as an appointed logistics provider for
              exhibitions at major trade shows around the world.
            </p>
          </div>
        </div>
      </TheHouseHold>
    </>
  );
};

const TheHouseHold = styled.div`
  width: 100%;
  background: #ffffff;

  .household-hero {
    position: relative;
    width: 100%;
    height: 45vh;
    min-height: 350px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(11, 30, 51, 0.8) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
      width: 100%;
      padding: 0 2rem;
      z-index: 1;

      h1 {
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.2rem;
        opacity: 0.9;
      }
    }
  }

  .household-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 4rem 2rem;
  }

  .hr-section {
    background: linear-gradient(135deg, #0b1e33 0%, #0a1a2c 100%);
    padding: 2.5rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;

    p {
      color: white;
      font-size: 1.1rem;
      line-height: 1.7;
    }
  }

  .equipment-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;
    border: 1px solid #e2e8f0;

    p {
      font-size: 1rem;
      color: #4a5568;
      line-height: 1.7;
    }
  }

  .exhibitions-section {
    background: #f8f9fa;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #d4af37;

    p {
      font-size: 1rem;
      color: #d4af37;
      line-height: 1.7;
      font-weight: 500;
    }
  }

  @media screen and (max-width: 900px) {
    .household-hero {
      height: 40vh;
      min-height: 300px;

      .hero-content h1 {
        font-size: 2.5rem;
      }

      .hero-content p {
        font-size: 1rem;
      }
    }

    .household-container {
      padding: 3rem 1.5rem;
    }

    .hr-section p {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 768px) {
    .household-hero {
      min-height: 250px;

      .hero-content h1 {
        font-size: 2rem;
      }
    }

    .household-container {
      padding: 2rem 1rem;
    }

    .hr-section,
    .equipment-section,
    .exhibitions-section {
      padding: 1.5rem;
    }
  }

  @media screen and (max-width: 600px) {
    .household-hero .hero-content h1 {
      font-size: 1.6rem;
    }

    .hr-section p,
    .equipment-section p,
    .exhibitions-section p {
      font-size: 0.95rem;
    }
  }

  @media screen and (max-width: 480px) {
    .household-hero .hero-content h1 {
      font-size: 1.3rem;
    }

    .household-hero .hero-content p {
      font-size: 0.9rem;
    }

    .hr-section,
    .equipment-section,
    .exhibitions-section {
      padding: 1rem;
    }
  }
`;

export default HouseHold;
